import { ErrorResolution } from '../../app/common/errorResolution/errorResolution';
import { IMasterAddress } from '../../api/addressSearch/addressSearch';
import { IAddress } from './address/address.interface';

export enum AddressesActionType {
    ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST',
    ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS',
    ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE',

    REMOVE_ADDRESS_REQUEST = 'REMOVE_ADDRESS_REQUEST',
    REMOVE_ADDRESS_SUCCESS = 'REMOVE_ADDRESS_SUCCESS',
    REMOVE_ADDRESS_FAILURE = 'REMOVE_ADDRESS_FAILURE',

    UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST',
    UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS',
    UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE',

    GET_ADDRESSES_REQUEST = 'GET_ADDRESSES_REQUEST',
    GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS',
    GET_ADDRESSES_FAILURE = 'GET_ADDRESSES_FAILURE',

    SET_DEFAULT_SHIPPING = 'SET_DEFAULT_SHIPPING',

    CLOSE_ADDRESS_FORM = 'CLOSE_ADDRESS_FORM',
    OPEN_ADDRESS_FORM = 'OPEN_ADDRESS_FORM',

    GET_MASTER_ADDRESS_REQUEST = 'GET_MASTER_ADDRESS_REQUEST',
    SET_MASTER_ADDRESS_REQUEST = 'SET_MASTER_ADDRESS_REQUEST',

    HIDDEN_ADDRESSES_UPDATED_INFO = 'HIDDEN_ADDRESSES_UPDATED_INFO',
    CHANGE_STATE_INPUT_DISABLED = 'CHANGE_STATE_INPUT_DISABLED',
}
export type AddressesAction =
    | { type: AddressesActionType.ADD_ADDRESS_SUCCESS; payload: { address: IAddress } }
    | { type: AddressesActionType.REMOVE_ADDRESS_SUCCESS; payload: { addressUuid: string } }
    | { type: AddressesActionType.UPDATE_ADDRESS_SUCCESS; payload: { address: IAddress } }
    | { type: AddressesActionType.GET_ADDRESSES_SUCCESS; payload: { addresses: IAddress[] } }
    | { type: AddressesActionType.CLOSE_ADDRESS_FORM; payload: {} }
    | { type: AddressesActionType.OPEN_ADDRESS_FORM; payload: {} }
    | IAddressesFailureAction
    | IAddressesRequestAction
    | { type: AddressesActionType.GET_MASTER_ADDRESS_REQUEST; payload: {} }
    | {
          type: AddressesActionType.SET_MASTER_ADDRESS_REQUEST;
          payload: { masterAddress: IMasterAddress | null };
      }
    | { type: AddressesActionType.HIDDEN_ADDRESSES_UPDATED_INFO; payload: {} }
    | { type: AddressesActionType.GET_ADDRESSES_REQUEST; payload: {} }
    | { type: AddressesActionType.CHANGE_STATE_INPUT_DISABLED; payload: boolean };
export interface IAddressesRequestAction {
    type:
        | AddressesActionType.ADD_ADDRESS_REQUEST
        | AddressesActionType.REMOVE_ADDRESS_REQUEST
        | AddressesActionType.UPDATE_ADDRESS_REQUEST
        | AddressesActionType.SET_DEFAULT_SHIPPING;
    payload: {};
}

export interface IAddressesFailureAction {
    type:
        | AddressesActionType.ADD_ADDRESS_FAILURE
        | AddressesActionType.REMOVE_ADDRESS_FAILURE
        | AddressesActionType.UPDATE_ADDRESS_FAILURE
        | AddressesActionType.GET_ADDRESSES_FAILURE;
    payload: { errorResolution: ErrorResolution };
}
